module.exports = __webpack_public_path__ + "b9033988330941b707b15b231c67d64c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/navbar/overview_redisign-active.png
// module id = 475
// module chunks = 0